'use client';

import { useEffect } from 'react';
import { datadogService } from '../api/datadog-service';
import { logger } from '@/core/logger';

export function DatadogProvider({ children }: { children: React.ReactNode }) {
	useEffect(() => {
		const initialized = datadogService.initialize();
		if (initialized) {
			logger.info('Datadog initialized', {
				pathname: window.location.pathname,
				referrer: document.referrer,
			});
		}
	}, []);

	return <>{children}</>;
}
